<script>
import CreateModal from './Modal.vue'

export default {
    props: {
        url: {
            required: true,
            type: String,
        },
    },
    components: {
        CreateModal,
    },
    data() {
        return {
            modal: false,
        }
    }
}
</script>

<template>
    <div class="text-center">
        <button type="button" class="btn btn-link fw-light" v-on:click="modal = true">
            Utaztál már velünk? Írd meg a véleményed te is <i class="fa-solid fa-arrow-right"></i>
        </button>

        <CreateModal
            v-if="modal"
            :url="url"
            v-on:closed="modal = false"
        />
    </div>
</template>

<style scoped>

</style>
